/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface EmployerDto {
  accessToken?: string;
  active?: boolean;
  employeeRole?: string;
  foxId?: string;
  id?: number;
  name?: string;
  salesForceId?: string;
  state?: string;
  type?: string;
  username?: string;
}
